// Notice.js

import React, { Component } from 'react';
import { Button, Form , Table, Input, Label } from 'react-bootstrap';
import Config from '../Config';

import ScrollArea from 'react-scrollbar';
import Modal from 'react-awesome-modal';

import { JsonToExcel } from 'react-json-excel';
import axios from 'axios';
import 'semantic-ui-css/semantic.min.css';
import {Icon} from 'semantic-ui-react';

import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import Column from 'react-virtualized/dist/commonjs/Table/Column';
import GTable from 'react-virtualized/dist/commonjs/Table';
import SortDirection from 'react-virtualized/dist/commonjs/Table/SortDirection';
import SortIndicator from 'react-virtualized/dist/commonjs/Table/SortIndicator';
import styles from './Table.css';

class MoreInformation extends Component {
    static defaultProps = {
        item: null,
        enable: false,
        Login: () => { },
        orderlist: [],
        visible: false,
        control: false,
        orderinfo: [],
        menu: ''

    }
    constructor(props) {
        super(props);
        this.state = {

            orderlist: [],
            name: '',
            status: '',
            number: '',
            address1: '',
            address2: '',
            postcode: '',
            city: '',
            state: '',
            exportnumber: '',
            invoicenumber: '',
        }
        this.packing = ['안전봉투', '조립박스', '골판지박스'];
        this.shipping = ['K_PACK', 'EMS', '국내배송'];
        this.post = ['','결제요청중', '결제완료', '상품준비중', '배송중', '배송완료'];
    }

    onclose() {
        this.props.onPress();
        this.props.onreset();
    }

    onsave() {
        Config.fetchData('adminOrderUpdate', ({
            "ORDER_ID": this.props.orderinfo.ID,
            NAME: this.state.name,
            PHONE: this.state.number,
            ADDRESS1: this.state.address1,
            ADDRESS2: this.state.address2,
            ZIP: this.state.postcode,
            CITY: this.state.city,
            STATE: this.state.state,
            MEMO: this.props.orderinfo.MEMO,
            EXPORTNUMBER: this.state.exportnumber,
            INVOICENUMBER: this.state.invoicenumber
        }), (result, count) => {
        }, true);
        Config.fetchData('adminUpdateStatus', ({
            "ORDER_ID": this.props.orderinfo.ID,
            STATUS: this.state.status

        }), (result, count) => {
        }, true);
    }

    nameButton(event) {
        if (this.props.control == true) {
            this.setState({ name: event.target.value })
        } else { null }
    }

    numberButton(event) {
        if (this.props.control == true) {
            this.setState({ number: event.target.value })
        } else { null }
    }
    statusButton(event) {
        this.setState({ status: this.post.findIndex((el) => el == event.target.value) })
    }

    address1Button(event) {
        if (this.props.control == true) {
            if (this.props.orderinfo.STATUS < 3) {
                this.setState({ address1: event.target.value })
            }
            else {
                null
            }
        } else { null }
    }

    address2Button(event) {
        if (this.props.control == true) {
            if (this.props.orderinfo.STATUS < 3) {
                this.setState({ address2: event.target.value })
            }
            else {
                null
            }
        } else { null }
    }

    postcodeButton(event) {
        if (this.props.control == true) {
            if (this.props.orderinfo.STATUS < 3) {
                this.setState({ postcode: event.target.value })
            }
            else {
                null
            }
        } else { null }
    }
    cityButton(event) {
        if (this.props.control == true) {
            if (this.props.orderinfo.STATUS < 3) {
                this.setState({ city: event.target.value })
            }
            else {
                null
            }
        } else { null }
    }
    stateButton(event) {
        if (this.props.control == true) {
            if (this.props.orderinfo.STATUS < 3) {
                this.setState({ state: event.target.value })
            }
            else {
                null
            }
        } else { null }
    }
    exportnumberButton(event) {
        if (this.props.control == true) {
            if (this.props.orderinfo.STATUS < 3 && this.props.orderinfo.COUNTRY != 'KR') {
                this.setState({ exportnumber: event.target.value })
            }
            else {
                null
            }
        } else { null }
    }
    invoicenumberButton(event) {
        if (this.props.orderinfo.STATUS < 4) {
            this.setState({ invoicenumber: event.target.value })
        }
        else {
            null
        }
    }



    componentWillReceiveProps() {
        this.setState({ name: this.props.orderinfo.NAME });
        this.setState({ number: this.props.orderinfo.PHONE });
        this.setState({ status: this.props.orderinfo.STATUS });
        this.setState({ address1: this.props.orderinfo.ADDRESS1 });
        this.setState({ address2: this.props.orderinfo.ADDRESS2 });
        this.setState({ postcode: this.props.orderinfo.ZIP });
        this.setState({ city: this.props.orderinfo.CITY });
        this.setState({ state: this.props.orderinfo.STATE });
        this.setState({ country: this.props.orderinfo.COUNTRY });
        this.setState({ exportnumber: this.props.orderinfo.EXPORTNUMBER });
        this.setState({ invoicenumber: this.props.orderinfo.INVOICENUMBER });
    }

    render() {
        return (
            <Modal transparent={true} visible={this.props.visible} width="70%" >
                <div className="box" >
                    <div className="row" style={{ margin: 20 }}>
                        <table>
                            <tr>
                                <td>
                                    <Button onClick={this.onclose.bind(this)}>닫기</Button>
                                </td>
                                <td>
                                    <Button onClick={this.onsave.bind(this)}>저장</Button>
                                </td>
                            </tr>
                        </table>
                        <Table striped bordered hover>
                            <thead>
                                <tr width={"100"} align-items={'center'}>
                                    <th>수신자 이름</th>
                                    <th>수신자 번호</th>
                                    <th>배송현황</th>
                                    <th>우편번호</th>
                                    <th>송장번호</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><Form.Control type="title" value={this.state.name} onChange={this.nameButton.bind(this)} /></td>
                                    <td><Form.Control type="title" value={this.state.number} onChange={this.numberButton.bind(this)} /></td>
                                    <td><Form.Control as="select" value={this.post[this.state.status]} onChange={this.statusButton.bind(this)}>
                                        <option>{this.post[1]}</option>
                                        <option>{this.post[2]}</option>
                                        <option>{this.post[3]}</option>
                                        <option>{this.post[4]}</option>
                                        <option>{this.post[5]}</option>
                                    </Form.Control></td>
                                    <td><Form.Control type="title" value={this.state.postcode} onChange={this.postcodeButton.bind(this)} /></td>
                                    <td><Form.Control type="title" value={this.state.invoicenumber} onChange={this.invoicenumberButton.bind(this)} /></td>
                                </tr>
                            </tbody>
                            <thead>
                                <tr width={"100"} align-items={'center'}>
                                    <th>주소</th>
                                    <th>상세주소</th>
                                    <th>도시</th>
                                    <th>지역</th>
                                    <th>수출신고번호</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><Form.Control type="title" value={this.state.address1} onChange={this.address1Button.bind(this)} /></td>
                                    <td><Form.Control type="title" value={this.state.address2} onChange={this.address2Button.bind(this)} /></td>
                                    <td><Form.Control type="title" value={this.state.city} onChange={this.cityButton.bind(this)} /></td>
                                    <td><Form.Control type="title" value={this.state.state} onChange={this.stateButton.bind(this)} /></td>
                                    <td><Form.Control type="title" value={this.state.exportnumber} onChange={this.exportnumberButton.bind(this)} /></td>
                                </tr>
                            </tbody>
                        </Table>


                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>배송국가</th>
                                    <th>{this.props.orderinfo.COUNTRY}</th>
                                </tr>
                                <tr>
                                    <th>총금액</th>
                                    <th>{this.props.orderinfo.TOTALPRICE}</th>
                                </tr>
                                <tr>
                                    <th>포장재</th>
                                    <th>{this.packing[this.props.orderinfo.PACK]}</th>
                                </tr>
                                <tr>
                                    <th>배송방법</th>
                                    <th>{this.shipping[this.props.orderinfo.KIND]}</th>
                                </tr>
                            </thead>
                        </Table>
                        <ScrollArea style={{ width: '100%', height: 480 }}>
                            <Table striped bordered hover>
                                <thead>
                                    <tr width={"100"} align-items={'center'}>
                                        <th>사진</th>
                                        <th>사이즈</th>
                                        <th>수량</th>
                                        <th>사진가격</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.orderlist.map((item) =>
                                        <tr>
                                            <table width="30" height="150">
                                                <img src={`${Config.S3Server}/contents/${item.PCODE}/pthumbs/${item.PNAME}`} height="100%"></img>
                                            </table>
                                            <td>{item.PSIZE}</td>
                                            <td>{item.PAMOUNT}</td>
                                            <td>{item.PRICE.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                        </tr>
                                    )}
                                </tbody>

                            </Table>
                        </ScrollArea>
                    </div>
                </div>
            </Modal>
        )
    }
}


// class RowItem extends Component {
//     static defaultProps = {
//         item: null,
//         enable: false,
//         control: false,
//         onPress: () => { }
//     }
//     constructor(props) {
//         super(props);
//         this.state = {
//             visible: false,
//             orderlist: [],
//             moreinfovisible: false,
//             orderadmin: []
//         };

//         this.post = ['','결제요청중', '결제완료', '상품준비중', '배송중', '배송완료'];
//         this.shipping = ['K_PACK', 'EMS', '국내배송'];
//     }



//     handleRowClick = () => {
//         this.setState({ visible: !this.state.visible })
//         this.props.onPress(this.props.item);
//         event.preventDefault();
//     }
//     render() {
//         return (
//             <tr onClick={this.handleRowClick}>
//                 <td>{this.props.item.ID}</td>
//                 <td>{this.props.item.NAME}</td>
//                 <td>{this.props.item.PHONE}</td>
//                 <td>{this.props.item.ORDER_EMAIL}</td>
//                 <td>{this.props.item.COUNTRY}</td>
//                 <td>{this.props.item.ADDRESS1}</td>
//                 <td>{this.props.item.ADDRESS2}</td>
//                 <td>{this.props.item.ZIP}</td>
//                 <td>{this.props.item.ORDER_PHONE}</td>
//                 <td>{this.props.item.ORDER_NAME}</td>
//                 <td>{this.shipping[this.props.item.KIND]}</td>
//                 <td>{this.props.item.MEMO}</td>
//                 <td>{this.post[this.props.item.STATUS]}</td>
//                 <td>{this.props.item.ALLAMOUNT.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
//                 <td>{this.props.item.ORDERDATE}</td>
//                 {this.props.control == true ?
//                     <td>{this.props.item.TOKEN}</td>
//                     :
//                     null}
//                 <td>{this.props.item.TOTALWEIGHT}</td>
//                 <td>{this.props.item.CURRENCY}</td>
//                 <td>{this.props.item.TOTALPRICE.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
//                 <td>{this.props.item.EXPORTNUMBER}</td>
//             </tr>
//         );
//     }
// };

const className = 'class-name-for-style',
    filename = 'PicturePurchase_Excel-file',
    fields = {
        "ID": "ID",
        "NAME": "이름",
        "PHONE": "연락처",
        "ORDER_EMAIL": "Email",
        "COUNTRY": "국가코드",
        "ADDRESS1": "주소",
        "ADDRESS2": "상세주소",
        "CITY": "도시",
        "STATE": "지역",
        "ZIP": "우편번호",
        "ORDER_PHONE": "주문인 연락처",
        "ORDER_NAME": "주문인 이름",
        "KINDKR": "배송방법",
        "MEMO": "배송요청사항",
        "STATUSKR": "배송상태",
        "ALLAMOUNT": "배송비",
        "ORDERDATE": "주문일자",
        "TOKEN": "TOKEN",
        "TOTALWEIGHT": "총 무게(g)",
        "PACKKR": "포장재",
        "ALLPRICE": "가격",
        "CURRENCY": "결제통화",
        "TOTALPRICE": "TOTAL",
        "newDate": "시간",
        "ORDER_ID": "주문자번호",
        "EXPORTNUMBER": "수출신고번호",
    },
    style = {
        padding: "5px",
        background: "#3c8dbc",
        border: "1px #367fa9",
        borderRadius: "3px",
        padding: "6px 12px",
        color: "#ffffff",
        font: "14px",
        height: "37.64px"
    }
  


export default class PicturePurchase extends Component {
    static defaultProps = {
        item: null,
        enable: false,
        onPress: () => { },
        onreset: () => { },
        control: false
    }
    constructor(props) {
        super(props);
        this.state = {
            sendcount: 0,
            rowlist: [],
            answervisible: false,
            moreinfovisible: false,
            //file: null,
            selectedFile: null,
            item: { TITLE: '제목을 입력하세요.', CONTENT: '내용을 입력하세요.', LANGUAGE_CODE: 'ko', COUNTRY_CODE: 'KR' }
        };
        this.post = ['','결제요청중', '결제완료', '상품준비중', '배송중', '배송완료'];
        this.shipping = ['K_PACK', 'EMS', '국내배송'];
        this.packing = ['안전봉투', '조립박스', '골판지박스'];
        this.handleReturn = this.handleReturn.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.fileUpload = this.fileUpload.bind(this);
        this.onFormSubmits = this.onFormSubmits.bind(this);
        this.onChanges = this.onChanges.bind(this);
        this.fileUploads = this.fileUploads.bind(this);
        this.rowlist = [];
        this.subMenuName = {
            'PicturePurchase': '전체주문목록',
                'RequestingPayment': '결제요청건',
                'PaymentFinished': '결제완료',
                'PreparingProduct': '상품준비중',
                'Shipping': '배송중',
                'DeliveryCompleted': '배송완료'};
    }
    handleChange(event) {
        var item = this.state.item;
        item.TITLE = event.target.value;
        this.setState({ item: item });
    }

    handleChangeContent(event) {
        var item = this.state.item;
        item.CONTENT = event.target.value;
        this.setState({ item: item });
    }

    handleChangeLang(event) {
        var item = this.state.item;
        item.LANGUAGE_CODE = event.target.value;
        this.setState({ item: item });
    }

    handleChangeCountry(event) {
        this.setState({ country: event.target.value });
    }

    handleReturn(event) {

        // Config.fetchData('insnotice' , {
        //     COUNTRY_CODE: this.state.item.COUNTRY_CODE,
        //     LANGUAGE_CODE: this.state.item.LANGUAGE_CODE,
        //     TITLE: this.state.item.TITLE,
        //     CONTENT: this.state.item.CONTENT
        // }, (result, count) => {
        //     console.log('insnotice=', count);
        //     this.setState({sendcount : count})
        // }, true);    

        event.preventDefault();
    }

    handleRemove(event) {

        // Config.fetchData('delnotice' , {
        //     ID : this.state.item.ID,
        //     COUNTRY_CODE: this.state.item.COUNTRY_CODE,
        //     LANGUAGE_CODE: this.state.item.LANGUAGE_CODE
        // }, (result, count) => {
        //     console.log('delnotice=', count);
        //     this.setState({sendcount : count})
        // }, true);    

        event.preventDefault();
    }

    handleRowClick = (event) => {
        var item = event.rowData;
        console.log(item);
        this.setState({ orderinfo: item });
        Config.fetchData('getOrderList', ({ "ORDER_ID": item.ID }), (result, count) => {
            console.log('result=', result);
            this.setState({ orderlist: result })
            this.setState({ moreinfovisible: true })
        }, true);
    }

    onclose(val) {
        this.setState({ moreinfovisible: val })
    }

    componentDidMount() {
        var menu = this.props.menu;
        var statusJson = {
            'PicturePurchase': 0,
            'RequestingPayment': 1,
            'PaymentFinished': 2,
            'PreparingProduct': 3,
            'Shipping': 4,
            'DeliveryCompleted': 5,

        };
        if (this.props.menu == 'PicturePurchase') {
            Config.fetchData('adminOrder', ({}), (result, count) => {
                console.log('result=', result);
                result.forEach(element => {
                    element.STATUSKR = this.post[element.STATUS];
                    element.KINDKR = this.shipping[element.KIND];
                    element.PACKKR = this.packing[element.PACK];
                });
                this.setState({ rowlist: result })
                console.log('rowlist=', this.rowlist);
            }, true);
        } else {
            Config.fetchData('selectedOrder', ({STATUS : statusJson[menu]}), (result, count) => {
                console.log('result=', result);
                result.forEach(element => {
                    element.TEST =  this.post[element.STATUS];
                    element.KINDKR = this.shipping[element.KIND];
                    element.PACKKR = this.packing[element.PACK];
                });
                this.setState({ rowlist: result })
                console.log('rowlist=', this.rowlist);
            }, true);
        }
    }

    handleClose = () => {
        console.log('handleClose');
        this.setState({ answervisible: false });
    }

    handleScroll(scrollData) {
        console.log(scrollData);
    }

    _noRowsRenderer() {
        return <div>No rows</div>;
    }

    _onScrollToRowChange(event) {
        const {rowCount} = this.state;
        let scrollToIndex = Math.min(
          rowCount - 1,
          parseInt(event.target.value, 10),
        );
    
        if (isNaN(scrollToIndex)) {
          scrollToIndex = undefined;
        }
    
        this.setState({scrollToIndex});
    }

    _rowClassName({index}) {
        if (index < 0) {
            return "headerRow";
        } else {
            return index % 2 === 0 ? "evenRow" : "oddRow";
        }
    }

    onFormSubmit(e){
        e.preventDefault() // Stop form submit
        if (this.state.file === null) {
            return;
        }
        this.fileUpload().then((response)=>{
          console.log(response.data);
    
          //alert(response.data);
        })
    
    }
    
    onChange(e) {
        this.setState({file:e.target.files[0]});
        this.refs._userfileName.value = e.target.files[0].name;
    }
    
    fileUpload(){
        const url = `${Config.Server}/file-uploadStatus`
    
        //var formData = new FormData(target);
    
        var formData = new FormData();
        formData.append('csv',this.state.file);
        const config = {
            headers: {
                'content-type'  : 'multipart/form-data' // multer 사용시 multipart/form-data 형식이어야 한다.
            }
        }
        axios.post(url, formData, config)
        .then( (response) => {
            console.log(response);
            if( response.data.count >= 0 ) {
                alert(`${response.data.count}건이 변경되었습니다.`);
                this.componentDidMount();
            } 
            else {
                alert('형식을 지원하지 않습니다.');
            }
        })
        .catch(function (error) {
            alert(error);
        });
    }

    onFormSubmits(e){
        e.preventDefault() // Stop form submit
        if (this.state.file === null) {
            return;
        }
        this.fileUploads().then((response)=>{
          console.log(response.data);
    
          //alert(response.data);
        })
    
    }
    
    onChanges(e) {
        this.setState({file:e.target.files[0]});
        this.refs._userfileNames.value = e.target.files[0].name; 
    }
    
    fileUploads(){
        const url = `${Config.Server}/file-uploadExportNumber`
    
        //var formData = new FormData(target);
    
        var formData = new FormData();
        formData.append('csv',this.state.file);
        const config = {
            headers: {
                'content-type'  : 'multipart/form-data' // multer 사용시 multipart/form-data 형식이어야 한다.
            }
        }
        axios.post(url, formData, config)
        .then( (response) => {
            if( response.data.count >= 0 ) {
                alert(`${response.data.count}건이 변경되었습니다.`);
                this.componentDidMount();
            }
            else {
                alert('형식을 지원하지 않습니다.');
            }
        })
        .catch(function (error) {
            alert(error);
        });
    }
    
    render() {
        let scrollbarStyles = { borderRadius: 5 };
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="box-header with-border">
                                    <table>
                                        <tr>
                                            <td>
                                                <h3 className="box-title">{this.subMenuName[this.props.menu]}</h3>
                                            </td>
                                            <td width="16"></td>
                                            <td>
                                                {this.state.rowlist.length > 0 ?
                                                    <JsonToExcel
                                                        data={this.state.rowlist}
                                                        className={className}
                                                        filename={filename}
                                                        fields={fields}
                                                        style={style}
                                                    />
                                                    :
                                                    null
                                                }
                                            </td>
                                            <td width="10"></td>
                                            <td>
                                                {this.props.menu == 'PreparingProduct' ?
                                                    <Form className="FileUpload" onSubmit={this.onFormSubmit}>
                                                        <div class = "ui action input">
                                                            <input placeholder='선택된파일...' type="text" ref="_userfileName" class="ui"/>
                                                            <label for="userfile" class="ui icon button">
                                                            <Icon name="attach" />
                                                            <input type="file" id="userfile" accept=".xlsx, .xls" style={{display: "none"}} onChange={this.onChange}/>
                                                            </label>
                                                            <Button basic ref={(param)=>this.uploadButton = param} color="purple" type="submit">배송중으로 변경</Button>
                                                        </div>
                                                    </Form>
                                                    :
                                                    null
                                                }
                                            </td>
                                            <td width="10"></td>
                                            <td>
                                                {this.props.menu == 'PaymentFinished' ?
                                                    <Form className="FileUpload" onSubmit={this.onFormSubmits}>
                                                        <div class = "ui action input">
                                                            <input placeholder='선택된파일...' type="text" ref="_userfileNames" class="ui"/>
                                                            <label for="userfiles" class="ui icon button">
                                                            <Icon name="attach" />
                                                            <input type="file" id="userfiles" accept=".xls" style={{display: "none"}} onChange={this.onChanges}/>
                                                            </label>
                                                            <Button basic ref={(param)=>this.uploadButton = param} color="purple" type="submit">수출신고번호 등록</Button>
                                                        </div>
                                                    </Form>
                                                    :
                                                    null
                                                }
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div className="box-body" style={{ margin: 20 }}>
                                    <div className="row">
                                        <AutoSizer disableHeight>
                                            {({width}) => (
                                            <GTable
                                                ref="Table"
                                                headerClassName={'headerColumn'}
                                                onRowClick={this.handleRowClick}
                                                headerHeight={30}
                                                height={800}
                                                noRowsRenderer={this._noRowsRenderer}
                                                overscanRowCount={10}
                                                rowClassName={this._rowClassName}
                                                rowHeight={40}
                                                rowGetter={({index}) => this.state.rowlist[index]}
                                                rowCount={this.state.rowlist.length}
                                                scrollToIndex={this.state.scrollToIndex}
                                                width={width}>
                                                <Column
                                                width={100}
                                                disableSort
                                                label="주문번호"
                                                dataKey="ID"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={120}
                                                disableSort
                                                label="이름"
                                                dataKey="NAME"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={130}
                                                disableSort
                                                label="연락처"
                                                dataKey="PHONE"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={210}
                                                disableSort
                                                label="EMAIL"
                                                dataKey="ORDER_EMAIL"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={50}
                                                disableSort
                                                label="국가"
                                                dataKey="COUNTRY"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={150}
                                                disableSort
                                                label="주소"
                                                dataKey="ADDRESS1"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={100}
                                                disableSort
                                                label="상세주소"
                                                dataKey="ADDRESS2"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={90}
                                                disableSort
                                                label="우편번호"
                                                dataKey="ZIP"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={140}
                                                disableSort
                                                label="주문인연락처"
                                                dataKey="ORDER_PHONE"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={120}
                                                disableSort
                                                label="주문인이름"
                                                dataKey="ORDER_NAME"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={100}
                                                disableSort
                                                label="배송방법"
                                                dataKey="KIND"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => this.shipping[cellData]}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={100}
                                                disableSort
                                                label="배송상태"
                                                dataKey="STATUS"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => this.post[cellData]}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={80}
                                                disableSort
                                                label="배송비"
                                                dataKey="ALLAMOUNT"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={200}
                                                disableSort
                                                label="주문일자"
                                                dataKey="ORDERDATE"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={110}
                                                disableSort
                                                label="총 무게(g)"
                                                dataKey="TOTALWEIGHT"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={100}
                                                disableSort
                                                label="결제통화"
                                                dataKey="CURRENCY"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={100}
                                                disableSort
                                                label="TOTAL"
                                                dataKey="TOTALPRICE"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={145}
                                                disableSort
                                                label="수출신고번호"
                                                dataKey="EXPORTNUMBER"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={130}
                                                disableSort
                                                label="송장번호"
                                                dataKey="INVOICENUMBER"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                            </GTable>
                                            )}
                                        </AutoSizer>
                                        {/* <ScrollArea style={{ width: '100%', height: 700 }}
                                            className="area"
                                            contentClassName="content"
                                            verticalScrollbarStyle={scrollbarStyles}
                                            verticalContainerStyle={scrollbarStyles}
                                            horizontalScrollbarStyle={scrollbarStyles}
                                            horizontalContainerStyle={scrollbarStyles}
                                            smoothScrolling={true}
                                            minScrollSize={20}
                                            onScroll={this.handleScroll}
                                        >
                                            <Table striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        <th>주문번호</th>
                                                        <th>이름</th>
                                                        <th>연락처</th>
                                                        <th>EMAIL</th>
                                                        <th>국가코드</th>
                                                        <th>주소</th>
                                                        <th>상세주소</th>
                                                        <th>우편번호</th>
                                                        <th>주문인 연락처</th>
                                                        <th>주문인 이름</th>
                                                        <th>배송방법</th>
                                                        <th>배송요청사항</th>
                                                        <th>배송상태</th>
                                                        <th>배송비</th>
                                                        <th>주문일자</th>
                                                        {this.props.control == true ?
                                                            <th>TOKEN</th>
                                                            :
                                                            null}
                                                        <th>총 무게(g)</th>
                                                        <th>결제통화</th>
                                                        <th>TOTAL</th>
                                                        <th>수출신고번호</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <MoreInformation visible={this.state.moreinfovisible} orderinfo={this.state.orderinfo} orderlist={this.state.orderlist} control={this.props.control} onreset={() => { this.componentDidMount() }} onPress={() => { this.onclose(false) }} />
                                                    {this.state.rowlist.map((item, index) =>
                                                        <RowItem key={index} item={item} onPress={this.handleRowClick} control={this.props.control} />
                                                    )}
                                                </tbody>
                                            </Table>
                                        </ScrollArea> */}
                                    </div>
                                    <MoreInformation visible={this.state.moreinfovisible}  orderinfo={this.state.orderinfo} orderlist={this.state.orderlist} control={this.props.control} onreset={() => { this.componentDidMount() }} onPress={() => { this.onclose(false) }} />
                                </div>
                                <div className="box-footer">
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-6">
                                            <div className="description-block border-right">
                                                {/* <span className="description-percentage text-green"><i className="fa fa-caret-up"></i> 17%</span> */}
                                                {/* <h5 className="description-header">Sending TOTAL: {this.state.sendcount}</h5> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        )
    }
}




// WEBPACK FOOTER //
// src/components/PicturePurchase.js